var _excluded = ["ratio", "children", "className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { tqc, forwardRef } from '../../system';
import { cx, mapResponsive, __DEV__ } from '../../utils';
import * as React from 'react';
/**
 * React component used to cropping media (videos, images and maps)
 * to a desired aspect ratio.
 */
export var AspectRatio = forwardRef((props, ref) => {
  var {
      ratio = 4 / 3,
      children,
      className
    } = props,
    rest = _objectWithoutProperties(props, _excluded);

  // enforce single child
  var child = React.Children.only(children);
  var _className = cx('tqc-aspect-ratio', className);
  return /*#__PURE__*/React.createElement(tqc.div, _extends({
    ref: ref,
    position: "relative",
    className: _className,
    _before: {
      height: 0,
      content: "\"\"",
      display: 'block',
      paddingBottom: mapResponsive(ratio, r => "".concat(1 / r * 100, "%"))
    },
    __css: {
      '& > *': {
        overflow: 'hidden',
        position: 'absolute',
        top: '0',
        right: '0',
        bottom: '0',
        left: '0',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%'
      },
      '& > img, & > video': {
        objectFit: 'cover'
      }
    }
  }, rest), child);
});
if (__DEV__) {
  AspectRatio.displayName = 'AspectRatio';
}